var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconoContacto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n        stroke-width: 0px;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.987,11.742c1.249-1.076,2.892.094,4.01.814.648.407,1.568,1.006,1.685,1.849.087.8-.803,1.525-1.292,2.054-1.156,1.273-2.66,1.979-4.378,2.054-.196-.009-.517-.009-.224.019-1.032-.126-2.007-.243-2.986-.608-.922-.333-1.771-.796-2.588-1.325-1.717-1.137-3.38-2.452-4.758-4.016-1.352-1.521-2.565-3.233-3.002-5.264-.386-1.905.016-3.763,1.25-5.264.444-.543,1.09-1.545,1.86-1.587.775-.042,1.397.575,1.863,1.104,1.013,1.133,2.698,2.799,1.467,4.339-.491.599-1.402,1.235-1.531,2.04-.131.795.447,1.568.906,2.143,1.05,1.287,2.478,2.546,3.971,3.308.664.319,1.518.604,2.18.136.648-.481.957-1.282,1.568-1.797Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoContacto);
export default __webpack_public_path__ + "static/media/icono-contacto.eb29e99089afe62e8577cf88a82ad65e.svg";
export { ForwardRef as ReactComponent };